import Cookies from 'js-cookie';

export function Dropdown() {
  document.addEventListener('DOMContentLoaded', () => {
    const languageDropdowns = document.querySelectorAll('.language-selector__dropdown');
    const categoryDropdowns = document.querySelectorAll('.category-select__dropdown');
    const languageSelectors = document.querySelectorAll('.language-selector');
    const categorySelectors = document.querySelectorAll('.category-select');
    const languageLists = document.querySelectorAll('.language-selector__list');
    const categoryLists = document.querySelectorAll('.category-select__list');

    function toggleDropdown(dropdowns, selectors, lists, index) {
      dropdowns[index].addEventListener('click', () => {
        Cookies.set('_fLS', '1');
        selectors[index].classList.toggle('is-open');
        if (selectors[index].classList.contains('is-open')) {
          lists[index].style.height = `${lists[index].scrollHeight}px`;
          document.querySelector('.primary-nav').style.height = 'auto';
        } else {
          lists[index].style.height = '0';
        }
      });
    }

    languageDropdowns.forEach((dropdown, index) => {
      toggleDropdown(languageDropdowns, languageSelectors, languageLists, index);
    });

    categoryDropdowns.forEach((dropdown, index) => {
      toggleDropdown(categoryDropdowns, categorySelectors, categoryLists, index);
    });
  });
}



// WEBPACK FOOTER //
// ./src/ktu/js/components/Dropdown.js